
import { NgModule, isDevMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthRoutingModule } from '../../../../src/app/pages/auth/auth-routing.module';
import { SharedModule } from '../../../../src/app/shared/shared.module';
import { MsalModule, MsalService, MsalInterceptor, MsalInterceptorConfiguration, MsalGuard, MsalGuardConfiguration, MsalBroadcastService, MsalRedirectComponent, MSAL_INTERCEPTOR_CONFIG, MSAL_INSTANCE, MSAL_GUARD_CONFIG } from "@azure/msal-angular";
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation } from "@azure/msal-browser";
import { AppComponent } from "../../app.component";
import { AppConfigService } from '../../_service/app-config.service';

export function MSALInstanceFactory(config: AppConfigService): IPublicClientApplication {
    const appconfig = JSON.parse(sessionStorage.getItem('appconfig') || '{}');
    let clientId = appconfig.clientId;
    let authority = appconfig.authority;
    let redirectUri = window.location.origin + '/home';
    // if(JSON.parse(sessionStorage.getItem('appconfig'))['clientId'])
    // clientId = JSON.parse(sessionStorage.getItem('appconfig'))['clientId']
    // if(JSON.parse(sessionStorage.getItem('appconfig'))['authority'])
    // authority = JSON.parse(sessionStorage.getItem('appconfig'))['authority'];

    let redirectUriPath = window.location.pathname.split('/')[1];

    let redirectUriFinal;
    let postLogoutRedirectUriFinal
    // if(isDevMode()){
    //   redirectUriFinal = window.location.origin  + '/home';   ///////////////Dev
    //   postLogoutRedirectUriFinal = window.location.origin + '/login'  //////Dev
    // }else{
    redirectUriFinal = window.location.origin + '/' + redirectUriPath + '/home',// Preprod/Prod

        postLogoutRedirectUriFinal = window.location.origin + '/' + redirectUriPath + '/login'// Preprod/Prod
    // }

    return new PublicClientApplication({
        auth: {
            clientId: clientId, // This is your client ID
            authority: authority, // This is your tenant ID
            redirectUri: redirectUriFinal,
            // redirectUri: window.location.origin  + '/home',// Dev
            postLogoutRedirectUri: postLogoutRedirectUriFinal
            // postLogoutRedirectUri:window.location.origin + '/login'  //////Dev
        }
    })
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
     const appconfig_1 = JSON.parse(sessionStorage.getItem('appconfig') || '{}');
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set(appconfig_1.scope, [appconfig_1.scopes]);

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
    };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    const appconfig_2 = JSON.parse(sessionStorage.getItem('appconfig') || '{}');
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: [appconfig_2.scopes],
        },
        loginFailedRoute: "./login-failed",
    };
}

@NgModule({
    declarations: [LoginComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        SharedModule,
        MsalModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true,
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
            deps: [AppConfigService],
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory,
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory,
        },
        MsalGuard,
        MsalBroadcastService,
        MsalService,
    ],
    bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AuthModule { }